// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "assets_js_modules_copyUrl_js") return "./js/chunks/494433b60edd5194355c.js";
	if (chunkId === "assets_js_modules_header_js") return "./js/chunks/9b2174c547ae7084024c.js";
	if (chunkId === "assets_js_modules_highlight_js") return "./js/chunks/b8e8e13ffe685c02ed32.js";
	// return url for filenames based on template
	return undefined;
};